import sendLocalRequest from "./sendLocalRequest";

export const clearAlertNotificationsLog = (auth_token, unique_id) => {
    return  new Promise( (resolve, reject) => {
        console.log("clearAlertNotificationsLog: " + unique_id);

        sendLocalRequest(`/machines/${unique_id}/clear_alert_notifications_log`, "DELETE", auth_token).then( (data) => {
            resolve(data);
        }).catch( (error) => {
            reject(error);
        })
    });



};
